// extracted by mini-css-extract-plugin
export default {"thumbnail__container":"style_thumbnail__container__u1EoM","thumbnail__img_container":"style_thumbnail__img_container__HQ-zS","img__label":"style_img__label__z1fQd"};